import { createContext } from 'react';
import type { Match } from '@gin-betting/match';
import { noop } from 'lodash';

interface IMarketsTabConfigsContext {
    marketsTabConfigsBySport: Match.MarketTabConfigBySport;
    setMarketsTabConfigsBySport: (
        state:
            | Match.MarketTabConfigBySport
            | ((
                  config: Match.MarketTabConfigBySport
              ) => Match.MarketTabConfigBySport)
    ) => void;
}

const MarketsTabConfigsContext = createContext<IMarketsTabConfigsContext>({
    marketsTabConfigsBySport: {},
    setMarketsTabConfigsBySport: noop,
});

export default MarketsTabConfigsContext;
